import { useState, useEffect } from 'react';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';

interface ShakespeareDeployFormProps {
  host?: string;
  projectId: string;
  onSubdomainChange: (subdomain: string) => void;
}

export function ShakespeareDeployForm({
  host = 'shakespeare.wtf',
  projectId,
  onSubdomainChange,
}: ShakespeareDeployFormProps) {
  const [subdomain, setSubdomain] = useState(projectId);

  useEffect(() => {
    onSubdomainChange(subdomain);
  }, [subdomain, onSubdomainChange]);

  const fullDomain = subdomain ? `${subdomain}.${host}` : `${projectId}.${host}`;

  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <Label className="text-sm font-medium">Subdomain</Label>
        <Input
          value={subdomain}
          onChange={(e) => setSubdomain(e.target.value)}
          placeholder={projectId}
          className="h-10 bg-background"
        />
      </div>
      <div className="rounded-lg bg-muted/50 border border-border/50 p-3 space-y-1">
        <p className="text-xs text-muted-foreground">
          Your site will be available at:
        </p>
        <p className="text-sm font-mono font-medium text-foreground">
          {fullDomain}
        </p>
      </div>
    </div>
  );
}
